import RESTClient from 'signin-app/api/clients/rest-client';
export const getLocale = () => {
    return RESTClient.getRequest('v2/locale');
};
